// API Configuration
const getBaseUrl = () => {
  // В development используем прокси через Vite
  if (import.meta.env.DEV) {
    return ''
  }
  // В production используем полный URL
  return 'https://yasha.ooguy.com:5002'
}

export const API_CONFIG = {
  BASE_URL: getBaseUrl(),
  API_KEY: 'hgo_web_FYNR44cdXDkUxx0QDC1Dl8lkrQavh5PY',
  ENDPOINTS: {
    STATS: '/api/stats/summary',
    APPLICATION: '/api/application/submit',
    BLACKLIST: '/api/blacklist/search',
    USERS: '/api/users/search',
    USER_PROFILE: '/api/users/{discord_id}/profile',
    RAFFLE_WINNERS: '/api/raffles/winners/last'
  }
} as const

// Helper function to get API headers
export const getApiHeaders = (contentType?: string) => {
  const headers: Record<string, string> = {
    'X-API-Key': API_CONFIG.API_KEY
  }
  
  if (contentType) {
    headers['Content-Type'] = contentType
  }
  
  return headers
}

// Types for user profile
export interface UserProfile {
  user: {
    id: string
    name: string
    display_name: string
    parsed: {
      name: string
      static_id: string
      real_name: string
    }
    avatar_url: string
    joined_at: string
  }
  roles: Array<{
    id: string
    name: string
    color: number
    position: number
  }>
  rank: string
  family_date: string
  stats: {
    points: number
    coins: number
    voice_hours: number
    voice_time_human: string
    contracts_completed: number
    contracts_earned: number
    applications_reviewed: number
  }
  badges: Array<{
    id: number
    name: string
    description: string
    image_url: string
    awarded_by: number
    awarded_at: string
  }>
  voice_channel: {
    id: string
    name: string
  }
}

// Types for raffle winners
export interface RaffleWinner {
  raffleId: string
  winner: {
    id: string
    discordId: string
  }
  completedAt: string
  participantCount: number
  scheduledAt: string
}

export interface RaffleWinnersResponse {
  winners: RaffleWinner[]
  total: number
}

// Function to get user profile
export const getUserProfile = async (discordId: string): Promise<UserProfile> => {
  const url = API_CONFIG.ENDPOINTS.USER_PROFILE.replace('{discord_id}', discordId)
  const fullUrl = `${API_CONFIG.BASE_URL}${url}`
  
  console.log('Fetching user profile:', fullUrl)
  console.log('Environment:', import.meta.env.MODE)
  console.log('Base URL:', API_CONFIG.BASE_URL)
  
  try {
    const response = await fetch(fullUrl, {
      method: 'GET',
      headers: getApiHeaders()
    })
    
    console.log('Response status:', response.status)
    
    if (!response.ok) {
      // Если статус не 200, считаем что пользователь не найден
      throw new Error(`404: User not found`)
    }
    
    const data = await response.json()
    console.log('Profile data received:', data)
    
    // Проверяем, что данные не пустые
    if (!data || Object.keys(data).length === 0) {
      throw new Error(`404: Empty response`)
    }
    
    return data
  } catch (error) {
    console.error('Error fetching user profile:', error)
    
    // Если это ошибка сети (failed to fetch) или любая другая ошибка
    // считаем что пользователь не найден
    if (error instanceof TypeError && error.message.includes('fetch')) {
      throw new Error(`404: Network error`)
    }
    
    // Для всех остальных ошибок также считаем что пользователь не найден
    throw new Error(`404: ${error instanceof Error ? error.message : 'Unknown error'}`)
  }
}

// Function to get raffle winners
export const getRaffleWinners = async (): Promise<RaffleWinnersResponse> => {
  const url = 'https://yasha.ooguy.com:8698/api/raffles/winners/last'
  
  console.log('Fetching raffle winners:', url)
  
  try {
    const response = await fetch(url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json'
      }
    })
    
    console.log('Winners response status:', response.status)
    
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`)
    }
    
    const data = await response.json()
    console.log('Winners data received:', data)
    
    return data
  } catch (error) {
    console.error('Error fetching raffle winners:', error)
    throw new Error(`Failed to fetch winners: ${error instanceof Error ? error.message : 'Unknown error'}`)
  }
} 